import { CREDIT_CARD_PAYMENT_METHOD } from 'src/comps/PaymentForm/constants'

const transformPaymentMethodData = paymentMethod => {
  if (paymentMethod === 'applePay') return 'apple_pay'
  return paymentMethod
}

export function buildSummaryRequest({
  purchaseId,
  paymentMethod,
  insuranceIds = [],
  pdpIds = [],
  payNowIds = [],
}) {
  return {
    purchase_id: purchaseId,
    insurance_ids: insuranceIds.join(','),
    pdp_ids: pdpIds.join(','),
    pay_now_ids: payNowIds.join(','),
    payment_provider:
      paymentMethod === CREDIT_CARD_PAYMENT_METHOD ? '' : transformPaymentMethodData(paymentMethod),
  }
}
